import { Link } from "react-router-dom";
import { categoryMeta, videos } from "@/mocks/videos";

export default function CategoryShortcuts() {
  return (
    <section className="px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">快捷分类</h2>
          <p className="mt-1.5 text-sm text-foreground-600">按类型快速进入你感兴趣的频道</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {categoryMeta.map((cat) => {
          const count = videos.filter((v) => v.type === cat.type).length;
          return (
            <Link
              key={cat.type}
              to={`/category/${cat.type}`}
              className="group relative flex items-start gap-4 p-5 md:p-6 rounded-lg bg-background-100 border border-background-300/50 hover:border-primary-400/60 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 shrink-0 rounded-lg bg-primary-500/15 text-primary-300 flex items-center justify-center">
                <i className={`${cat.icon} text-2xl`} />
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="font-heading font-semibold text-lg text-foreground-950">{cat.label}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-500/20 text-secondary-300">
                    {count} 部
                  </span>
                </span>
                <span className="block mt-1.5 text-sm text-foreground-600 leading-relaxed">{cat.desc}</span>
                <span className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-accent-500">
                  前往频道
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}